import { scaleLinear } from "d3-scale";
import { format } from "d3-format";
import { apnumber } from "journalize";

/**
 * @param {number} i
*/

export function addCommas(number) {
    if (number < 10) return apnumber(number)
    return format(",")(number);
}

export function formatRemainsOf(number, atleast=false, capitalizeFirstLetter=false, strong=false, strongNumber=false, morethan = false, numberonly = false) {
    var pretext = atleast ? " at least " : " ";
    pretext = morethan ? " more than " : pretext;
    let remainsof = capitalizeFirstLetter ? "Remains of" : "remains of";
    let numberParsed = (numberonly) ? format(",")(number) : number < 10 ? apnumber(number) : format(",")(number);
    if (strong || strongNumber) {
        if (number == 1) return remainsof + pretext + "<strong>" + numberParsed + "</strong> Native American"
        return remainsof + pretext + "<strong>" + numberParsed + "</strong> Native Americans"
    }
    if (number == 1) return remainsof + pretext + numberParsed + " Native American"
    return remainsof + pretext + numberParsed + " Native Americans"
    
}


export function capitalizeFirstLetter (string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export function slugify(str) {
    return str
        .toLowerCase()
        .trim()
        .replace(/[^\w\s-]/g, "")
        .replace(/[\s_-]+/g, "-")
        .replace(/^-+|-+$/g, "")
        .replaceAll("-of-", "-")
        .replaceAll("-the-", "-");
}

export function the(entity, capitalize = false, strong = false) {
    let returnString = "";
    if (
        entity.indexOf("County") == -1 &&
        entity.indexOf("College") == -1 &&
        (entity.indexOf("Univ.") == -1 ||
            entity.indexOf("Univ. of") >= 0) &&
        entity.indexOf("Museums") == -1
    ) {
        returnString = "the";
    }
    let wholeReturnString =
        returnString +
        (strong ? " <strong>" : " ") +
        entity +
        (strong ? "</strong>" : "");
    return capitalize
        ? capitalizeFirstLetter(wholeReturnString)
        : wholeReturnString;
}

export function ordinalFormat(i) {
    var j = i % 10,
        k = i % 100;
    if (j == 1 && k != 11) {
        return i + "st";
    }
    if (j == 2 && k != 12) {
        return i + "nd";
    }
    if (j == 3 && k != 13) {
        return i + "rd";
    }
    return i + "th";
};

export function titleCase(str) {
    var splitStr = str.toLowerCase().split(" ");
    for (var i = 0; i < splitStr.length; i++) {
        splitStr[i] =
            splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    splitStr = splitStr.join(" ");
    splitStr = splitStr.split("-");
    for (var i = 0; i < splitStr.length; i++) {
        splitStr[i] =
            splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    return splitStr.join("-");
}

export const colorScale = scaleLinear()
    .domain([0, 0.5, 1])
    .range([
        "rgba(214, 73, 12, 1)",
        "rgb(151, 140, 111)",
        "rgba(2, 99, 88, 1)",
    ]);

export function get_tribe_noun(str, capitalize=false) {
    var n = str.split(" ");
    return capitalize ? capitalizeFirstLetter(n[n.length - 1]) : n[n.length - 1];
}

export function pluralize(value, noun, strongAroundVal = false, numberAsWord = true, capitalize = false, overrideSingular = "") {
    value = +value
    let returnValue = "";
    let returnString = noun;

    if (value == 1 && overrideSingular != "") {
        returnString = overrideSingular
    } else if (value != 1) {
        if (overrideSingular != "" && value != 0) {
            returnString = overrideSingular;
        } else {
            returnString = noun + "s"
        }
    }

    if (numberAsWord) {
        returnValue = addCommas(value)
    } else {
        returnValue = format(",")(value)
    }

    if (strongAroundVal) {
        returnValue = "<strong>" + returnValue + "</strong>"
    }

    let wholeReturnString = returnValue + " " + returnString;

    return capitalize ? (wholeReturnString).charAt(0).toUpperCase() + wholeReturnString.slice(1) : wholeReturnString
}